import * as types from 'store/actions/types';

export function updateFeatureImage(url) {
    return (dispatch) => {
        dispatch({
            type: types.UPDATE_FEATURE_IMAGE,
            url
        });
    };
}